import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import React, { useEffect, useRef, useState } from 'react'
import cl from 'classnames'
import { Button } from '@/ui'
import { verificationActions, verificationThunks } from '@/entity/verification'
import { VERIFICATION_STEPS_NAME } from '@/entity/verification/constants'

const SECOND = 30

export const Error = () => {
	const dispatch = useDispatch()
	const { t } = useTranslation()
	const timerRef = useRef(null)

	const { iin } = useSelector(state => ({
		iin: state.verification.iin,
	}))

	const [secondsRemaining, setSecondsRemaining] = useState(SECOND)

	const startTimer = () => {
		clearTimer()
		const startTime = Date.now()
		const endTime = startTime + secondsRemaining * 1000

		timerRef.current = setInterval(() => {
			const now = Date.now()
			const newSeconds = Math.max(Math.ceil((endTime - now) / 1000), 0)

			setSecondsRemaining(newSeconds)

			if (newSeconds <= 0) {
				clearTimer()
			}
		}, 100)
	}

	const clearTimer = () => {
		if (timerRef.current) {
			clearInterval(timerRef.current)
			timerRef.current = null
		}
	}

	useEffect(() => {
		startTimer()
		return () => clearTimer()
	}, [])

	const handleClickButton = () => {
		dispatch(verificationActions.setStepName(VERIFICATION_STEPS_NAME.step3))
		dispatch(verificationThunks.sendPhoneForIin({ iin: iin.data?.iin }))
	}

	return (
		<div className={cl('flex', 'gap-4', 'p-4', 'align-items-center')}>
			{secondsRemaining ? <h4 className={cl('mb-0', 'text-secondary', 'text-center')} style={{width: 100}}>{secondsRemaining}</h4> : null}

			<Button
				textColor="green"
				borderColor="green"
				transparent
				border
				type="button"
				onClick={handleClickButton}
				disabled={secondsRemaining}
			>
				{t('resend')}
			</Button>
		</div>
	)
}